import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Fade,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material';
import Close from 'mdi-material-ui/Close'
import { forwardRef, useState, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'
import Editor from '../../components/editor'


const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />)

const DialogNotice = (props) => {
  const { show, setShow, setReload } = props
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState('');
  const defaultValues = {
    title: ''
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  useEffect(() => {
    if(!show) {
      reset(defaultValues);
      setContent('');
    }
  },[show]);

  const onSubmit = async (data, e) => {
    setLoading(true);

    const params = JSON.stringify({
      "title": data.title,
      "descript": content
    });

    try {
      await apiService.post('/notices', params);
      toast.success('업데이트 되었습니다.');
      setReload(reload => reload + 1);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShow(false);
    }
  }

  return (
    <Card>
      <Dialog
        fullWidth
        open={show}
        maxWidth='md'
        scroll='body'
        onClose={() => setShow(false)}
        TransitionComponent={Transition}
        onBackdropClick={() => setShow(false)}
      >
        <form onSubmit={handleSubmit(onSubmit)} id="noticeform">
          <DialogContent sx={{ pb: 3, px: { xs: 8, sm: 15 }, pt: { xs: 4, sm: 8 }, position: 'relative' }}>
            <IconButton
              size='small'
              onClick={() => setShow(false)}
              sx={{ position: 'absolute', right: '1rem', top: '1rem' }}
            >
              <Close />
            </IconButton>
            <Box sx={{ mb: 9, textAlign: 'center' }}>
              <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                공지 추가
              </Typography>
            </Box>

            <Grid container spacing={6}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name='title'
                    control={control}
                    rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        label='제목'
                        id='title'
                        onChange={onChange}
                        placeholder='제목을 입력해주세요'
                        error={Boolean(errors.title)}
                        aria-describedby='validation-async-title'
                        variant="standard"
                      />
                    )}
                  />
                  {errors.title && (
                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                      필수
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name='content'
                  control={control}
                  render={({ field: { value } }) => (
                  <Editor 
                    content={value}
                    setContent={setContent} />
                  )}
                />
              </Grid>

            </Grid>
          </DialogContent>
        </form>

        <DialogActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'center' }}>
          <Button type="submit" form="noticeform" variant='contained'>
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'common.white',
                  width: '20px !important',
                  height: '20px !important',
                  mr: theme => theme.spacing(2)
                }}
              />
            ) : null}
            등록
          </Button>
          <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
            취소
          </Button>
        </DialogActions>

      </Dialog>
    </Card>
  )
}

export default DialogNotice
